var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { Service } from '~/core/service';
var CaseInfoConfirmService = /** @class */ (function (_super) {
    __extends(CaseInfoConfirmService, _super);
    function CaseInfoConfirmService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 案件信息确认
     */
    CaseInfoConfirmService.prototype.confirmCaseInfo = function (data) {
        return this.netService.send({
            server: dataimpService.caseInfoConfirmController.confirmCaseInfo,
            data: {
                batchNumber: data.batchNumber,
                contractNumberList: data.contractNumberList,
                status: data.status
            },
        });
    };
    /**
     * 客户信息确认
     */
    CaseInfoConfirmService.prototype.confirmPersonalInfo = function (data) {
        return this.netService.send({
            server: dataimpService.caseInfoConfirmController.confirmPersonalInfo,
            data: data,
        });
    };
    /**
     * 案件确认
     */
    CaseInfoConfirmService.prototype.confirmProductInfo = function (data) {
        return this.netService.send({
            server: dataimpService.caseInfoConfirmController.confirmProductInfo,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseInfoConfirmService.prototype, "netService", void 0);
    return CaseInfoConfirmService;
}(Service));
export { CaseInfoConfirmService };
